/* RESPONSIBLE TEAM: team-workflows */
import type AnswerTerminal from 'embercom/models/operator/visual-builder/step/answer-terminal';
import StepConfig, { type StepConfigParams } from '../step';
import AttributeInfoResolver from 'embercom/lib/common/template-attribute-resolver';

export default class AnswerTerminalConfiguration extends StepConfig {
  declare step: AnswerTerminal;
  protected attributeService: any;

  constructor(
    params: Omit<StepConfigParams, 'component'> & { component?: string; attributeService: any },
  ) {
    super({
      component: 'workflows/graph-editor/node-items/steps/answer-terminal',
      ...params,
    });

    this.attributeService = params.attributeService;
  }

  get alignment() {
    return 'left' as const;
  }

  get attributeInfoResolver() {
    return new AttributeInfoResolver({
      attributes:
        this.step.editorConfig?.runtimeMatchingTargetingAttributes
          .map((group) => group.attributes)
          .flat() ?? this.attributeService.userEditorMetadataAndConversationAttributes,
      customObjectAttributes: this.attributeService.customObjectsAttributeDescriptors,
      includeAppAttributes: true,
      includeCustomObjectAttributes: true,
      localAttributes: this.step.editorConfig?.localAttributeGroupList,
      allLocalAttributes: this.step.editorConfig?.allLocalAttributeGroupList,
    });
  }
}
